import React, { Component } from 'react';
import { connect } from 'react-redux';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import {
  faHouse,
  faBallotCheck,
  faRightToBracket,
  faIdBadge,
  faUserSecret,
  faTriangleExclamation,
  faBrowsers,
  faFileUser,
  faGear,
  faPersonToDoor,
  faIdCard,
  faArrowRightToBracket,
  faClipboardUser,
  faUserVneckHairLong,
  faGraduationCap,
  faPaw,
  faCircleVideo,
  faBrain,
  faClipboardCheck,
} from '@fortawesome/pro-light-svg-icons';
import MenuListItem from './List/MenuListItem';
import { saveImpersonation, toggleImpersonation } from '../../Impersonation/actions';
import { toggleAccordion } from './actions';
import { checklists, profilePhoto, statusAlerts } from '../../../DataAccessLayer/services';
import { getData } from '../../../DataAccessLayer';
import { saveStatusAlerts, saveStatusAlertsIsError } from '../../StatusAlerts/actions';
import { saveChecklists, saveChecklistsIsError } from '../../Checklists/actions';
import {
  isUserAdmin,
  isUserAdvisor,
  isUserPowerUser,
  isUserImpersonationUser,
  isUserSAM,
  getUser,
  isUserATS,
} from '../utils';
import WithRouter from '../Router/WithRouter';
import ExpandableMenuListItem from './List/ExpandableMenuListItem';
import PortalAvatar from './PortalAvatar';
import { identifyUser, logIn, logOut } from '../../../AWS';
import { saveUser } from '../../../AWS/actions';
import { ssa } from '../../../DataAccessLayer/services';
import { transformStudentProgressNotifcations } from '../../StatusAlerts/utils';

export const isProfileUrlValid = (img) => {
  if (img == null)
    // if img is null or undefined
    return false;
  if (img.includes('placeholder')) return false;
  return true;
};

class Navigation extends Component {
  state = {
    img: '',
    isStatusAlertsLoading: false,
    isChecklistsLoading: false,
  };
  logOut = () => {
    this.props.saveUser({});
    this.props.saveImpersonation({});
    logOut();
  };
  componentDidMount() {
    if (!this.props.statusAlerts && !this.props.isStatusAlertsError) {
      this.loadStatusAlerts();
    }
    if (!this.props.checklists && !this.props.isChecklistsError) {
      this.loadChecklists();
    }
    // TODO: Add the photo details to redux to avoid making this call everytime the screen is resized to mobile size or vice versa
    this.loadProfilePhoto();
  }

  componentDidUpdate(prevProps) {
    if (this.props.isUserPhoto == !prevProps.isUserPhoto) {
      this.loadProfilePhoto();
    }
  }

  componentWillUnmount() {
    if (this.state.img) {
      URL.revokeObjectURL(this.state.img);
    }
  }

  checkIsActive = (page) => {
    const pathName = window.location.pathname;
    // The pathName for home page is '/', and the pathName for the rest of the pages starts with '/', Eg: for checklists page it is '/checklists' and for admin page it is '/admin' etc.
    // Using just the else condition (without the if block) to detemine the active tab, is always returning true for home tab even though the user is not on the home page, because the value passed to this method for home tab is '/' and this is included in the pathNames of all the pages.
    // Hence, handled the home page scenario in a separate if block.
    if (page === '/') {
      // Home page
      return pathName === '/';
    } else {
      // Rest of the pages
      return pathName.toLowerCase().includes(page.toLowerCase());
    }
  };

  loadStatusAlerts = async () => {
    this.setState({
      isStatusAlertsLoading: true,
    });

    try {
      const [statusAlertsData, studentProgressNotificationsData] = await Promise.all([
        getData(statusAlerts, true),
        getData(ssa.notifications(), true),
      ]);

      const studentProgressNotifications = transformStudentProgressNotifcations(
        studentProgressNotificationsData,
      );

      this.props.saveStatusAlerts({
        ...statusAlertsData,
        studentProgressNotifications,
      });
    } catch (err) {
      this.props.saveStatusAlertsIsError(true);
    } finally {
      this.setState({ isStatusAlertsLoading: false });
    }
  };

  loadChecklists = () => {
    this.setState({
      isChecklistsLoading: true,
    });
    getData(checklists, true)
      .then((checklists) => {
        this.props.saveChecklists(checklists?.checklists); // Also marks Checklists isError to false in the redux
      })
      .catch((err) => {
        this.props.saveChecklistsIsError(true);
        console.log(err);
      })
      .finally(() => this.setState({ isChecklistsLoading: false }));
  };

  loadProfilePhoto = () => {
    if (this.props.isUserPhoto && !this.state.img) {
      getData(profilePhoto, false, true).then((result) => {
        const imgUrl = URL.createObjectURL(result);
        this.setState({
          img: imgUrl,
        });
      });
    }
  };
  onClickNavigationItem = (navigateTo) => {
    //if on mobile, close the menu
    if (this.props.isMobile) {
      //This could potentially give some user feedback about the menu.
      //side effect is that if user had sideNav open, shrunk window then
      //navigated somewhere on mobile menu, THEN enlarged window their
      //side nav would be closed.
      //BUT it does keep the state of the menu consistent.
      //will address later if issue
      this.props.onToggle();
    }
    this.props.navigate(navigateTo);
  };

  identifyUser = async () => {
    const user = await identifyUser();
    console.log('User:', user);
    this.props.saveUser(user);
  };

  render() {
    const isLoggedIn = this.props.user?.firstName ? true : false;
    const user = getUser(this.props.user, this.props.impersonation);

    const isPowerUser = isUserPowerUser(user);
    const isImpersonationUser = isUserImpersonationUser(user);
    const isAdmin = isUserAdmin(user);
    const isSAM = isUserSAM(user);
    const isATS = isUserATS(user);
    // const isFacultyStaff = isUserFacultyStaff(user);
    const isAdvisor = isUserAdvisor(user);
    // const isStudent = isUserStudent(user);
    const isChecklistAvailable =
      !this.state.isChecklistsLoading &&
      !this.props.isChecklistsError &&
      this.props.checklists?.length > 0;

    /*
            We display the various email services depending on the user preference 'EmailService'
            The logic is to show Outlook by default and in some cases show Gmail instead or show both.
                - If the value is 'gmail' or 'both' then we display the Gmail item in the sidenav.
                - If the value is 'gmail' then we *do not* display the Outlook item in the sidenav.
                - If the value is anything other than 'gmail' then we *do* display the Outlook item.
        */
    const expandableItems = [
      {
        isVisible: isAdvisor,
        title: 'Advisor',
        icon: faUserVneckHairLong,
        url: 'https://itsapps.odu.edu/advisor/',
      },
      {
        title: 'Canvas',
        img: 'canvasWhiteOutline.svg',
        url: 'https://canvas.odu.edu/',
      },
      {
        title: 'Degree Works',
        icon: faGraduationCap,
        url: 'https://dw-prod.ec.odu.edu/responsiveDashboard',
      },
      {
        isVisible: ['both', 'gmail'].includes(
          this.props.preferences?.DisplayOptions?.Options?.EmailService,
        ),
        title: 'Gmail',
        img: 'gmailWhiteOutline.svg',
        url: 'https://mail.google.com/a/odu.edu',
      },
      {
        isVisible: this.props.preferences?.DisplayOptions?.Options?.EmailService !== 'gmail',
        title: 'Outlook',
        img: 'outlookWhiteOutline.svg',
        url: 'https://outlook.odu.edu/',
      },
      {
        title: 'LeoOnline',
        img: 'leoOnlineWhite.svg',
        url: 'https://www.odu.edu/administrative-banner-systems/leo-online',
      },
      {
        title: 'Papers',
        img: 'papersWhite.svg',
        url: 'https://jobs.odu.edu/hr',
      },
      {
        title: 'Student360',
        img: 'student360WhiteOutline.svg',
        url: 'https://success.odu.edu/',
      },
      {
        title: 'Student Resources',
        icon: faPaw,
        url: 'https://www.odu.edu/sees/student-resources',
      },
    ];

    const atsExpandableItems = [
      {
        title: 'Courses',
        icon: faCircleVideo,
        onClick: () => {
          this.onClickNavigationItem('/ats/courses');
        },
      },
      {
        title: 'Codecs',
        icon: faCircleVideo,
        onClick: () => {
          this.onClickNavigationItem('/ats/codecs');
        },
      },
      {
        title: 'Action History',
        icon: faCircleVideo,
        onClick: () => {
          this.onClickNavigationItem('/ats/actionHistory');
        },
      },
    ];

    return (
      <React.Fragment>
        <nav
          className={
            'myOdu__navigation ' +
            (this.props.isMobile ? 'mobile ' : 'desktop ') +
            (this.props.data.isOpen ? 'open ' : ' closed')
          }
        >
          <PortalAvatar
            isMenuOpen={this.props.data.isOpen}
            isLoggedIn={isLoggedIn}
            user={user}
            img={this.state.img}
            isMobile={this.props.isMobile}
          />

          {/* {this.props.isTopNav && <>
                    <Divider style={{backgroundColor: 'white'}}/>
                </>
                } */}

          <Divider style={{ backgroundColor: 'white' }} />

          <List sx={{ pt: 0 }}>
            {!isLoggedIn && (
              <MenuListItem
                data={{
                  title: 'Sign In',
                  isOpen: this.props.data.isOpen,
                }}
                icon={faRightToBracket}
              />
            )}
            {isLoggedIn && (
              <React.Fragment>
                {
                  //Accessible to Admins only
                  isAdmin && (
                    <MenuListItem
                      title="Admin Panel"
                      isOpen={this.props.data.isOpen}
                      icon={faIdBadge}
                      onClick={() => this.props.navigate('/admin')}
                      isActive={this.checkIsActive('admin')}
                    />
                  )
                }

                {/* //TODO: uncomment, test and fill in the blanks when power users
                                //are ready to roll out */}
                {/* {((isAdmin || isPowerUser) && !isImpersonationUser) &&
                                    //TODO: rename, give icon, route etc
                                    <MenuListItem
                                        title="Power User Panel Here"
                                        isOpen={this.props.data.isOpen}
                                        icon={faIdBadge}
                                        onClick={() =>
                                            this.props.navigate('/admin')
                                        }
                                        isActive={this.checkIsActive('admin')}
                                    />
                                } */}

                {/* Accessible to Admins and Users having Impersonation Priviledges */}
                {(isAdmin || isImpersonationUser) && (
                  <MenuListItem
                    role="button"
                    title="Impersonate"
                    isOpen={this.props.data.isOpen}
                    icon={faUserSecret}
                    onClick={this.props.toggleImpersonation}
                  />
                )}

                {isAdmin && (
                  <>
                    <MenuListItem
                      className="d-block d-sm-none"
                      role="button"
                      title="Identify User"
                      isOpen={this.props.data.isOpen}
                      icon={faIdCard}
                      onClick={this.identifyUser}
                    />
                    {/* <MenuListItem
                                                className="d-block d-sm-none"
                                                role="button"
                                                title="Release Version"
                                                isOpen={this.props.data.isOpen}
                                                icon={faUserSecret}
                                                onClick={ this.props .toggleImpersonation }
                                            /> */}
                  </>
                )}

                {(isAdmin || isPowerUser || isImpersonationUser) && (
                  <li>
                    <Divider style={{ backgroundColor: 'white' }} />
                  </li>
                )}
              </React.Fragment>
            )}

            <MenuListItem
              className="d-block d-sm-none"
              title="My Info"
              isOpen={this.props.data.isOpen}
              icon={faFileUser}
              onClick={() => this.onClickNavigationItem('/myInfo')}
              isActive={this.checkIsActive('myInfo')}
            />
            <MenuListItem
              className="d-block d-sm-none"
              title="Settings"
              isOpen={this.props.data.isOpen}
              icon={faGear}
              onClick={() => this.onClickNavigationItem('/settings')}
              isActive={this.checkIsActive('settings')}
            />
            <li className="d-block d-sm-none">
              <Divider style={{ backgroundColor: 'white' }} />
            </li>
            <MenuListItem
              title="Home"
              isOpen={this.props.data.isOpen}
              icon={faHouse}
              onClick={() => this.onClickNavigationItem('/')}
              isActive={this.checkIsActive('/')}
            />
            <MenuListItem
              title="Status Alerts"
              isOpen={this.props.data.isOpen}
              icon={faTriangleExclamation}
              badgeCount={
                !this.state.isStatusAlertsLoading && this.props.isStatusAlertsError
                  ? '?'
                  : this.props.statusAlertsCount
              }
              onClick={() => this.onClickNavigationItem('/statusAlerts')}
              isActive={this.checkIsActive('statusAlerts')}
            />
            <MenuListItem
              title="Checklists"
              isOpen={this.props.data.isOpen}
              icon={faBallotCheck}
              variant={isChecklistAvailable ? 'dot' : ''}
              badgeCount={
                !this.state.isChecklistsLoading && this.props.isChecklistsError
                  ? '?'
                  : isChecklistAvailable
                    ? ''
                    : 0
              }
              onClick={() => this.onClickNavigationItem('/checklists')}
              isActive={this.checkIsActive('checklists')}
            />
            {(isAdmin || isSAM) && (
              <MenuListItem
                role="button"
                title="Student Advisor Mgmt"
                ariaLabel="Student Advisor Management"
                isOpen={this.props.data.isOpen}
                icon={faClipboardUser}
                onClick={() => {
                  this.props.navigate('/sam');
                }}
              />
            )}
            <MenuListItem
              role="button"
              title="MonarchMind"
              isOpen={this.props.data.isOpen}
              icon={faBrain}
              onClick={() => {
                this.props.navigate('/monarchMind');
              }}
            />
            {(isAdmin || isATS) && (
              <ExpandableMenuListItem
                isSideNavOpen={this.props.data.isOpen}
                isMobile={this.props.isMobile}
                icon={faCircleVideo}
                title="ATS"
                ariaLabel="Academic Technical Services"
                expandableItems={atsExpandableItems}
                isMenuItemOpen={this.props.accordions?.ats ?? !this.props.isMobile}
                onToggleAccordion={() => this.props.toggleAccordion('ats')}
                onClickTitle={() => this.onClickNavigationItem('/ats')}
              />
            )}
            <ExpandableMenuListItem
              isSideNavOpen={this.props.data.isOpen}
              isMobile={this.props.isMobile}
              icon={faBrowsers}
              title="Systems"
              expandableItems={expandableItems}
              isMenuItemOpen={this.props.accordions?.systems ?? !this.props.isMobile}
              onToggleAccordion={() => this.props.toggleAccordion('systems')}
              onClickTitle={() => this.onClickNavigationItem('/systems')}
            />
            <li className="d-block d-sm-none">
              <Divider style={{ backgroundColor: 'white' }} />
            </li>
            <MenuListItem
              className="d-block d-sm-none"
              title="Sign Out"
              isOpen={this.props.data.isOpen}
              icon={faPersonToDoor}
              onClick={() => this.logOut()}
            />
            {isAdmin && (
              <MenuListItem
                className="d-block d-sm-none"
                role="button"
                title="Sign In"
                isOpen={this.props.data.isOpen}
                icon={faArrowRightToBracket}
                onClick={() => logIn()}
              />
            )}
          </List>
        </nav>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.AWSReducer.user,
    preferences: state.preferencesReducer.preferences,
    impersonation: state.impersonationReducer.impersonation,
    statusAlerts: state.myStatusAlertsReducer.statusAlerts,
    statusAlertsCount: state.myStatusAlertsReducer.count,
    isStatusAlertsError: state.myStatusAlertsReducer.isError,
    checklists: state.myChecklistsReducer.checklists,
    isChecklistsError: state.myChecklistsReducer.isError,
    isUserPhoto: state.preferencesReducer.preferences.DisplayOptions?.Options?.isUserPhoto ?? false,
    accordions: state.headerReducer.accordions || {},
  };
};

const mapDispatchToProps = (dispatch) => ({
  toggleAccordion: (key) => dispatch(toggleAccordion(key)),
  toggleImpersonation: () => dispatch(toggleImpersonation()),
  saveStatusAlerts: (statusAlerts) => dispatch(saveStatusAlerts(statusAlerts)),
  saveStatusAlertsIsError: (isError) => dispatch(saveStatusAlertsIsError(isError)),
  saveChecklists: (checklists) => dispatch(saveChecklists(checklists)),
  saveChecklistsIsError: (isError) => dispatch(saveChecklistsIsError(isError)),
  saveUser: (user) => dispatch(saveUser(user)),
  saveImpersonation: (impersonation) => dispatch(saveImpersonation(impersonation)),
});

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(Navigation));
